<template>
  <div @wheel.prevent="slide">
    <Header_en/>
    <Index_index_en/>
    <Index_concept_en id="index_concept_en"/>
    <Index_team_en id="index_team_en"/>
    <Index_enterprise_en id="index_enterprise_en"/>
    <Index_news_en id="index_news_en"/>
    <index_contact_en id="index_contact_en"/>
    <index_affix_en/>
    <router-view></router-view>
  </div>
</template>

<script>
import Header_en from '../../components/EN/Header_en'
import Index_index_en from "@/components/EN/index/Index_index_en";
import Index_concept_en from "@/components/EN/index/Index_concept_en";
import Index_team_en from "@/components/EN/index/Index_team_en";
import Index_enterprise_en from "@/components/EN/index/Index_enterprise_en";
import Index_news_en from "@/components/EN/index/Index_news_en";
import Index_contact_en from "@/components/EN/index/Index_contact_en";
import Index_affix_en from "@/components/EN/index/Index_affix_en";
import {onMounted, reactive} from "vue";


export default {
  name: 'Index_en',
  components: {
    Header_en,
    Index_index_en,
    Index_concept_en,
    Index_team_en,
    Index_enterprise_en,
    Index_news_en,
    Index_contact_en,
    Index_affix_en,
  },
  setup() {
    let time = reactive({
      prev: Date.now(),
      now: Date.now(),
      delay: 1000,
    })
    const slide = () => {
      time.now = Date.now()
      if (time.now - time.prev > time.delay) {
        if (window.event.deltaY > 0) {
          if(window.innerHeight <= document.getElementById('index_contact_en').getBoundingClientRect().top){
          document.documentElement.scrollBy({
            top: window.innerHeight,
            behavior: "smooth",
          })}
        } else {
          document.documentElement.scrollBy({
            top: -window.innerHeight,
            behavior: "smooth",
          })
        }
        time.prev = Date.now()
      }
    }
    let height = window.innerHeight
    onMounted(() => {
      let concept = document.getElementById('index_concept_en')
      let team = document.getElementById('index_team_en')
      let enterprise = document.getElementById('index_enterprise_en')
      let news = document.getElementById('index_news_en')
      let contact = document.getElementById('index_contact_en')

      window.addEventListener('resize', () => {
        // 当top大于0小于offsettop 表明在视窗内
        console.log(window.innerHeight, height)
        if (window.innerHeight > height) {
          if (concept.getBoundingClientRect().top > 0 && concept.getBoundingClientRect().top < concept.offsetTop) {
            window.scrollTo(0, window.innerHeight)
          } else if (team.getBoundingClientRect().top > 0 && team.getBoundingClientRect().top < team.offsetTop) {
            console.log('team')
            window.scrollTo(0, window.innerHeight * 2)
          } else if (enterprise.getBoundingClientRect().top > 0 && enterprise.getBoundingClientRect().top < enterprise.offsetTop) {
            console.log('enterprise')
            window.scrollTo(0, window.innerHeight * 3)
          } else if (news.getBoundingClientRect().top > 0 && news.getBoundingClientRect().top < news.offsetTop) {
            window.scrollTo(0, window.innerHeight * 4)
          } else if (contact.getBoundingClientRect().top > 0 && contact.getBoundingClientRect().top < contact.offsetTop) {
            window.scrollTo(0, window.innerHeight * 5)
          }
          height = window.innerHeight
        }
        else{
          if (concept.getBoundingClientRect().top > 0 && concept.getBoundingClientRect().top < concept.offsetTop) {
            console.log('concept')
            //window.scrollTo(0, window.innerHeight)
          } else if (team.getBoundingClientRect().top > 0 && team.getBoundingClientRect().top < team.offsetTop) {
            console.log('team')
            window.scrollTo(0, window.innerHeight)
          } else if (enterprise.getBoundingClientRect().top > 0 && enterprise.getBoundingClientRect().top < enterprise.offsetTop) {
            console.log('enterprise')
            window.scrollTo(0, window.innerHeight * 2)
          } else if (news.getBoundingClientRect().top > 0 && news.getBoundingClientRect().top < news.offsetTop) {
            window.scrollTo(0, window.innerHeight * 3)
          } else if (contact.getBoundingClientRect().top > 0 && contact.getBoundingClientRect().top < contact.offsetTop) {
            window.scrollTo(0, window.innerHeight * 4)
          }
          height = window.innerHeight
        }

      })
    })
    return {slide}
  }
}
</script>
<style scoped>
::-webkit-scrollbar {
  display: none
}
</style>
